const normalize = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')

const roleValues = (employee) => [
  employee?.userRole,
  employee?.role,
  employee?.role?.uniqueValue,
  employee?.role?.displayName,
  employee?.userRoleName,
]

export const isExecutiveWorkforceRecord = (employee) => {
  if (!employee || typeof employee !== 'object') return false

  const roles = roleValues(employee).map(normalize)
  return roles.some((role) => ['admin'].includes(role))
}

// A defensive UI boundary. The API is authoritative; this prevents a stale or
// third-party employee-list response from repopulating a selector in the UI.
export const hideExecutiveWorkforceRecords = (value) => {
  if (Array.isArray(value)) {
    return value
      .filter((item) => !isExecutiveWorkforceRecord(item))
      .map(hideExecutiveWorkforceRecords)
  }

  if (!value || typeof value !== 'object') return value

  return Object.entries(value).reduce((result, [key, nestedValue]) => {
    result[key] = hideExecutiveWorkforceRecords(nestedValue)
    return result
  }, {})
}
